<template>

    <modal-container class="modal-container--short">

        <!-- Top navbar -->
        <modal-header
            :title="''"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <!-- Prompt content -->
        <prompt-div>
            <!-- Layout body -->
            <template v-slot:body>
                <lottie class="loading-animation--absolute-middle" :options="{animationData: $root.loadAnimation}" v-if="initLoad" />

                <div :class="{'invisible':initLoad}">
                    <img class="m-3" src="/images/illustration-cash-exists.svg">
                    <h3 class="font-weight-bolder font-xl">You have an unfinished application</h3>
                    <div class="text-dark-grey mb-6">You still haven't finished your <span class="font-weight-bolder" v-html="existingProductName"></span> order. Don't you worry you can continue where you left off.</div>
                    <button class="btn btn-primary w-100 font-lg" @click="keepExisting()">Continue checkout</button>
                    <div v-if="differentFromExisting()" class="text-green p-3 font-weight-bolder" @click="cancelThenCheckout()">Start new application</div>
                </div>
            </template>
        </prompt-div>
    </modal-container>

</template>

<script>
    import productMixin from '../../../components/productMixin'

    export default {
        mixins: [productMixin],

        data: function() {
            return {
                initLoad: true,
                productForCheckout: null,
                existingProduct: null,
            }
        },
        methods: {
          keepExisting: function() {
            // analytics

            if(this.$store.state.session.formsGenposCompatible) {
                window.location.replace("exit?location=forms_genpos");
            } else {
                window.location.replace("exit?location=dashboard");
            }
          },
          cancelThenCheckout: function() {
            // analytics

            this.startCheckoutProcess({productId: this.productForCheckout, source: this.$root.modalParams.source, gposChangeItem: true, gposPreapproved: false})
          },
          differentFromExisting: function() {
            let existingProductId = _.get(this.existingProduct, 'id', false);
            return !(this.productForCheckout === existingProductId)
          }
        },
        computed: {
            existingProductName: function() {
                return _.get(this.existingProduct, 'productName', '')
            }
        },
        created: function() {
            // analytics

            let data = this.$store.state.session.noticeDetails.data;

            this.productForCheckout = this.$root.modalParams.productForCheckout

            axios
                .get("product/" + data.prevProductId + "/fetch")
                .then(response => {
                    this.existingProduct = response.data['product']

                    this.initLoad = false;
                })
        }
    }
</script>

<style scoped>
.prompt-container {
    margin: 0 2.8rem 1rem 2.8rem; /** override for text wrap **/
}
</style>
